export const columnsForType = {
  acquisition: [
    'createdBy',
    'generatedData',
    'messages',
    'status',
    'attendedAt',
    'origin',
    'score',
    'createdAt',
    'actionsAcquisition',
  ],
  development: [
    'createdBy',
    'generatedData',
    'status',
    'messages',
    'tags',
    'origin',
    'jtbdCompleted',
    'jtbds',
    'score',
    'createdAt',
    'actionsDevelopment',
  ],
} as const

export type ConversationTableTypeEnum = keyof typeof columnsForType
